// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  --background-color-buttons: var(--ion-color-background);
  --social-login-title-content-flex-grow: 1;
  --justify-content: normal;
  --gap: 0;
}
:host .social_login_content {
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: var(--justify-content);
  gap: var(--gap);
}
:host .social_login_title-content {
  flex-grow: var(--social-login-title-content-flex-grow);
}
:host .social_login_title-content .social_login_title {
  text-align: center;
  margin-bottom: 20px;
}
:host .social_login_hr {
  width: 100%;
  display: flex;
  flex-direction: row;
  text-transform: uppercase;
  border: none;
  margin-top: 22px;
  margin-bottom: 22px;
}
:host .social_login_hr:before, :host .social_login_hr:after {
  content: "";
  border-bottom: 1.5px solid #c2c8d0;
  flex: 1 0 auto;
  height: 0.7em;
}
:host .social_login_hr span {
  text-align: center;
  flex: 0.2 0 auto;
}
:host .social_login_buttons ::ng-deep app-buttons-footer .footer-content {
  --flex-flow: column nowrap;
  --gap: 22px;
  --app-space-content-top: 0;
  --app-space-content-right: 0;
  --app-space-content-bottom: 0;
  --app-space-content-left: 0;
  background-color: var(--background-color-buttons);
}
:host .buttons-default-content ::ng-deep app-buttons-footer .footer-content {
  --app-space-content-top: 0;
  --app-space-content-right: 0;
  --app-space-content-left: 0;
  background-color: var(--background-color-buttons);
}
:host .buttons-default-content ::ng-deep app-buttons-footer .appointment-button-default {
  --color: #969696;
  --border-color: #969696;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/social-login/social-login.component.scss"],"names":[],"mappings":"AAAA;EACI,uDAAA;EACA,yCAAA;EACA,yBAAA;EACA,QAAA;AACJ;AACI;EACI,aAAA;EACA,YAAA;EACA,sBAAA;EACA,uCAAA;EACA,eAAA;AACR;AAEI;EACI,sDAAA;AAAR;AACQ;EACI,kBAAA;EACA,mBAAA;AACZ;AAGI;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;AADR;AAEQ;EAEI,WAAA;EACA,kCAAA;EACA,cAAA;EACA,aAAA;AADZ;AAGQ;EACI,kBAAA;EACA,gBAAA;AADZ;AAOY;EACI,0BAAA;EACA,WAAA;EACA,0BAAA;EACA,4BAAA;EACA,6BAAA;EACA,2BAAA;EACA,iDAAA;AALhB;AAYY;EACI,0BAAA;EACA,4BAAA;EACA,2BAAA;EACA,iDAAA;AAVhB;AAaY;EACI,gBAAA;EACA,uBAAA;AAXhB","sourcesContent":[":host {\r\n    --background-color-buttons: var(--ion-color-background);\r\n    --social-login-title-content-flex-grow: 1;\r\n    --justify-content: normal;\r\n    --gap: 0;\r\n\r\n    .social_login_content {\r\n        display: flex;\r\n        height: 100%;\r\n        flex-direction: column;\r\n        justify-content: var(--justify-content);\r\n        gap: var(--gap);\r\n    }\r\n\r\n    .social_login_title-content {\r\n        flex-grow: var(--social-login-title-content-flex-grow);\r\n        .social_login_title {\r\n            text-align: center;\r\n            margin-bottom: 20px;\r\n        }\r\n    }\r\n\r\n    .social_login_hr {\r\n        width: 100%;\r\n        display: flex;\r\n        flex-direction: row;\r\n        text-transform: uppercase;\r\n        border: none;\r\n        margin-top: 22px;\r\n        margin-bottom: 22px;\r\n        &:before,\r\n        &:after {\r\n            content: '';\r\n            border-bottom: 1.5px solid #c2c8d0;\r\n            flex: 1 0 auto;\r\n            height: 0.7em;\r\n        }\r\n        span {\r\n            text-align: center;\r\n            flex: 0.2 0 auto;\r\n        }\r\n    }\r\n\r\n    .social_login_buttons {\r\n        ::ng-deep app-buttons-footer {\r\n            .footer-content {\r\n                --flex-flow: column nowrap;\r\n                --gap: 22px;\r\n                --app-space-content-top: 0;\r\n                --app-space-content-right: 0;\r\n                --app-space-content-bottom: 0;\r\n                --app-space-content-left: 0;\r\n                background-color: var(--background-color-buttons);\r\n            }\r\n        }\r\n    }\r\n\r\n    .buttons-default-content {\r\n        ::ng-deep app-buttons-footer {\r\n            .footer-content {\r\n                --app-space-content-top: 0;\r\n                --app-space-content-right: 0;\r\n                --app-space-content-left: 0;\r\n                background-color: var(--background-color-buttons);\r\n            }\r\n\r\n            .appointment-button-default {\r\n                --color: #969696;\r\n                --border-color: #969696;\r\n            }\r\n        }\r\n    }\r\n\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
